import type { PreferredVersions } from '../resolver-base/index.ts';
import semver from 'semver';

export function hoistPeers(
  missingRequiredPeers: Array<[string, { range: string }]>,
  opts: {
    autoInstallPeers: boolean;
    allPreferredVersions?: PreferredVersions | undefined;
  }
): Record<string, string> {
  const dependencies: Record<string, string> = {};

  for (const [peerName, { range }] of missingRequiredPeers) {
    if (opts.allPreferredVersions?.[peerName]) {
      const versions: string[] = [];

      const nonVersions: string[] = [];

      for (const [spec, specType] of Object.entries(
        opts.allPreferredVersions[peerName]
      )) {
        if (specType === 'version') {
          versions.push(spec);
        } else {
          nonVersions.push(spec);
        }
      }

      dependencies[peerName] = [
        semver.maxSatisfying(versions, '*', { includePrerelease: true }),
        ...nonVersions,
      ].join(' || ');
    } else if (opts.autoInstallPeers) {
      dependencies[peerName] = range;
    }
  }

  return dependencies;
}

export function getHoistableOptionalPeers(
  allMissingOptionalPeers: Record<string, string[]>,
  allPreferredVersions: PreferredVersions
): Record<string, string> {
  const optionalDependencies: Record<string, string> = {};

  for (const [missingOptionalPeerName, ranges] of Object.entries(
    allMissingOptionalPeers
  )) {
    if (!allPreferredVersions[missingOptionalPeerName]) {
      continue;
    }

    let maxSatisfyingVersion: string | undefined;

    for (const [version, specType] of Object.entries(
      allPreferredVersions[missingOptionalPeerName]
    )) {
      if (
        specType === 'version' &&
        ranges.every((range) => semver.satisfies(version, range)) &&
        (typeof maxSatisfyingVersion === 'undefined' ||
          semver.gt(version, maxSatisfyingVersion))
      ) {
        maxSatisfyingVersion = version;
      }
    }

    if (typeof maxSatisfyingVersion !== 'undefined') {
      optionalDependencies[missingOptionalPeerName] = maxSatisfyingVersion;
    }
  }

  return optionalDependencies;
}
